module.exports = __webpack_public_path__ + "c8e8bed26da1cad3608c98b70e980709.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/banniere/banniere-strategie.jpg
// module id = 140
// module chunks = 0